import { Badge, cn } from '@wundo/ui';

/** The emoji people reacted with, on the side of the bubble they belong to. */
export function MessageReactions({
  reactions,
  fromUser,
}: {
  reactions: Record<string, number> | null;
  fromUser: boolean;
}) {
  const given = Object.entries(reactions ?? {}).filter(([, count]) => count > 0);
  if (given.length === 0) return null;

  return (
    <div className={cn('flex gap-1', fromUser ? 'justify-end' : 'justify-start')}>
      {given.map(([emoji, count]) => (
        <Badge key={emoji} tone='quiet' title={emoji}>
          {emoji}
          {count > 1 ? ` ${count}` : ''}
        </Badge>
      ))}
    </div>
  );
}
